// Pure — no imports, no side effects. Safe to deep-import
// (`@coverright/data-access/apollo-clients/graphql-error-type`) from Next.js
// SSR contexts, unlike `get-apollo-client.ts` which pulls in the keycloak
// barrel (module-level `document`/`Keycloak` access) at import time.
export enum GraphQLErrorType {
  NO_CONNECTION = 'NO_CONNECTION',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  INVALID_EMAIL = 'INVALID_EMAIL',
  ERROR_STATUS = 'ERROR_STATUS'
}
